import SplashStory from './SplashStory';
import {
  MITRA_PLAY_STORE,
  MITRA_SPLASH_SCREENS,
  MITRA_STORY_UI,
} from './loksy-landing/mitraSplash';

export default function LoksyMitraStory() {
  return (
    <SplashStory
      screens={MITRA_SPLASH_SCREENS}
      playStore={MITRA_PLAY_STORE}
      loginTo="/locsydashboard"
      brandMark="/images/brand/mitra-mark.png"
      ui={MITRA_STORY_UI}
      documentTitle="Loksy Vyapar — Run and grow your shop"
    />
  );
}
